import CryptoJS from "crypto-js";

const encryptionKey = process.env.REACT_APP_ES1;
const saltBytes = CryptoJS.enc.Base64.parse(process.env.REACT_APP_SOLT_BYTES);

const sha256WordArray = (wordArray) => {
	return CryptoJS.SHA256(wordArray);
};

const sha512WordArray = (wordArray) => {
	return CryptoJS.SHA512(wordArray);
};

const wordArrayToUint8Array = (wordArray) => {
	const words = wordArray.words;
	const sigBytes = wordArray.sigBytes;
	const u8 = new Uint8Array(sigBytes);
	for (let i = 0; i < sigBytes; i++) {
		u8[i] = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	}
	return u8;
};

const uint8ArrayToWordArray = (u8) => {
	const words = [];
	for (let i = 0; i < u8.length; i++) {
		words[i >>> 2] |= u8[i] << (24 - (i % 4) * 8);
	}
	return CryptoJS.lib.WordArray.create(words, u8.length);
};

const getIV = (inputBytes) => {
	const sha256Hash = sha256WordArray(uint8ArrayToWordArray(inputBytes));
	const sha512Hash = sha512WordArray(sha256Hash);
	let u8 = wordArrayToUint8Array(sha512Hash);

	u8 = u8.filter((_, idx) => idx % 2 !== 0);

	const final = new Uint8Array(32);
	final.set(u8.slice(0, 32));

	return final.slice(10, 26);
};

const getKey = (inputBytes) => {
	const sorted = [...inputBytes].sort((a, b) => a - b);

	const sha512Hash = sha512WordArray(uint8ArrayToWordArray(sorted));
	let u8 = wordArrayToUint8Array(sha512Hash);

	u8 = u8.filter((_, idx) => idx % 2 === 0);

	const final = new Uint8Array(32);
	final.set(u8.slice(0, 32));

	const sha256Final = sha256WordArray(
		uint8ArrayToWordArray(final.slice(14, 30))
	);
	let keyBytes = wordArrayToUint8Array(sha256Final);

	keyBytes = keyBytes.reverse();

	return keyBytes;
};

const deriveKeyAndIV = (iterations) => {
	const passHash = sha256WordArray(CryptoJS.enc.Utf8.parse(encryptionKey));

	const pbkdf2 = CryptoJS.PBKDF2(passHash, saltBytes, {
		keySize: (32 + 16) / 4,
		iterations: iterations,
		hasher: CryptoJS.algo.SHA256,
	});

	const allBytes = wordArrayToUint8Array(pbkdf2);
	let keyPart = allBytes.slice(0, 32);
	let ivPart = allBytes.slice(32, 48);

	ivPart = getIV(ivPart);
	keyPart = getKey(keyPart);

	return { key: keyPart, iv: ivPart };
};

export const decrypt = (encryptedBase64, iterations = 2000) => {
	const decodedBase64 = decodeURIComponent(encryptedBase64);

	const { key, iv } = deriveKeyAndIV(iterations);

	const keyWA = uint8ArrayToWordArray(key);
	const ivWA = uint8ArrayToWordArray(iv);

	const decrypted = CryptoJS.AES.decrypt(
		{ ciphertext: CryptoJS.enc.Base64.parse(decodedBase64) },
		keyWA,
		{
			iv: ivWA,
			mode: CryptoJS.mode.CBC,
			padding: CryptoJS.pad.Pkcs7,
		}
	);

	return CryptoJS.enc.Utf8.stringify(decrypted);
};

export const encrypt = (plainText, iterations = 2000) => {
	const { key, iv } = deriveKeyAndIV(iterations);

	const keyWA = uint8ArrayToWordArray(key);
	const ivWA = uint8ArrayToWordArray(iv);

	const encrypted = CryptoJS.AES.encrypt(
		CryptoJS.enc.Utf8.parse(plainText),
		keyWA,
		{
			iv: ivWA,
			mode: CryptoJS.mode.CBC,
			padding: CryptoJS.pad.Pkcs7,
		}
	);

	const encryptedBase64 = encrypted.ciphertext.toString(CryptoJS.enc.Base64);

	return encodeURIComponent(encryptedBase64);
};
